(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("YXTPC"), require("Vue"), require("axios"), require("Vuex"), require("VueI18n"));
	else if(typeof define === 'function' && define.amd)
		define(["YXTPC", "Vue", "axios", "Vuex", "VueI18n"], factory);
	else if(typeof exports === 'object')
		exports["YXTBIZ"] = factory(require("YXTPC"), require("Vue"), require("axios"), require("Vuex"), require("VueI18n"));
	else
		root["YXTBIZ"] = factory(root["YXTPC"], root["Vue"], root["axios"], root["Vuex"], root["VueI18n"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__5__, __WEBPACK_EXTERNAL_MODULE__15__, __WEBPACK_EXTERNAL_MODULE__17__, __WEBPACK_EXTERNAL_MODULE__62__) {
return 